exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-company-container{box-shadow:0 0 5px #ddd;width:100%;max-width:100%;padding:16px}\n", ""]);

// exports
